import './RangeSlider.css';
import { useState, useEffect } from 'react';

interface RangeSliderProps {
  min: number;
  max: number;
  minLimit: number;
  maxLimit: number;
  onChange: (min: number, max: number) => void;
  suffix?: string;
}

function RangeSlider({ min, max, minLimit, maxLimit, onChange, suffix = '' }: RangeSliderProps) {
  const [localMin, setLocalMin] = useState(min);
  const [localMax, setLocalMax] = useState(max);

  useEffect(() => {
    setLocalMin(min);
    setLocalMax(max);
  }, [min, max]);

  const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newMin = parseInt(e.target.value);
    if (newMin <= localMax) {
      setLocalMin(newMin);
      onChange(newMin, localMax);
    }
  };

  const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newMax = parseInt(e.target.value);
    if (newMax >= localMin) {
      setLocalMax(newMax);
      onChange(localMin, newMax);
    }
  };

  const getPercentage = (value: number) => {
    const percentage = ((value - minLimit) / (maxLimit - minLimit)) * 100;
    return Math.min(percentage, 100);
  };

  return (
    <div className="range-slider-wrapper">
      <div className="range-slider-display">
        <span className="range-value">{localMin}{suffix}</span>
        <span className="range-separator">to</span>
        <span className="range-value">{localMax}{suffix}</span>
      </div>

      <div className="range-slider-track">
        <div className="range-slider-inputs">
          <input
            type="range"
            min={minLimit}
            max={maxLimit}
            value={localMin}
            onChange={handleMinChange}
            className="range-slider-input min-input"
          />
          <input
            type="range"
            min={minLimit}
            max={maxLimit}
            value={localMax}
            onChange={handleMaxChange}
            className="range-slider-input max-input"
          />
        </div>
        <div
          className="range-slider-progress"
          style={{
            left: `${getPercentage(localMin)}%`,
            right: `${100 - getPercentage(localMax)}%`
          }}
        />
      </div>
    </div>
  );
}

export default RangeSlider;
